import { useAuthStore } from '@/store/auth';
import { getQueryClient } from './queryClient';
import { invalidateSessionSensitiveRequests } from '@/lib/sessionSensitiveRequestManager';

let hasHandledExpiration = false;

export function handleSessionExpired(): void {
    if (hasHandledExpiration) {
        return;
    }

    hasHandledExpiration = true;

    const { logout, setIsLoggingOut } = useAuthStore.getState();
    setIsLoggingOut(true);

    const queryClient = getQueryClient();
    queryClient.clear();

    logout();
    invalidateSessionSensitiveRequests();

    if (window.location.pathname !== '/login') {
        window.location.replace('/login');
    }
}
